function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M25.8469 6.27637C13.0655 6.27637 2.70408 16.6378 2.70408 29.4192V31.7105V43.6137C2.70408 45.4113 2.33758 47.1901 1.62696 48.8414L0.5 51.46H26.398C38.8751 51.46 48.9898 41.3453 48.9898 28.8682C48.9898 16.3911 38.8751 6.27637 26.398 6.27637H25.8469ZM14.5795 32.6818C16.6129 32.6818 18.2613 31.0334 18.2613 29C18.2613 26.9666 16.6129 25.3182 14.5795 25.3182C12.5461 25.3182 10.8977 26.9666 10.8977 29C10.8977 31.0334 12.5461 32.6818 14.5795 32.6818ZM29.3068 29C29.3068 31.0334 27.6583 32.6818 25.6249 32.6818C23.5915 32.6818 21.9431 31.0334 21.9431 29C21.9431 26.9666 23.5915 25.3182 25.6249 25.3182C27.6583 25.3182 29.3068 26.9666 29.3068 29ZM36.6704 32.6818C38.7038 32.6818 40.3522 31.0334 40.3522 29C40.3522 26.9666 38.7038 25.3182 36.6704 25.3182C34.637 25.3182 32.9886 26.9666 32.9886 29C32.9886 31.0334 34.637 32.6818 36.6704 32.6818Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M21.9128 5.05022C23.9606 4.51378 26.1143 4.24417 28.3333 4.28187C40.6773 4.49157 50.8606 14.3808 51.2037 26.7219C51.2683 29.044 50.9884 31.2923 50.4115 33.4192C52.4164 30.1642 53.5402 26.3121 53.4536 22.1992C53.223 11.2485 44.3619 2.39015 33.4143 2.04154C29.2162 1.90785 25.2619 3.02407 21.9128 5.05022Z",
  clipRule: "evenodd",
  opacity: 0.6
});

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.98d92a22.svg";
export { ForwardRef as ReactComponent };